import {
  CellDescription,
  CellTooltip,
} from "components/shared/Contract/TableStickers";
import { lang } from "../../../i18nLang";
import { IColumn } from "../../shared/MuiVirtualizedTable/Cells";

export const columnsContract: IColumn[] = [
  {
    width: 120,
    label: lang("fields.code"),
    dataKey: "code",
    cellComponent: CellTooltip,
  },
  {
    width: 500,
    label: lang("fields.description"),
    dataKey: "description",
    flexGrow: 2,
    cellComponent: CellDescription,
  },
  {
    width: 144,
    label: lang("fields.quantity"),
    dataKey: "quantity",
    align: "right",
  },
  {
    width: 96,
    label: lang("fields.unit"),
    dataKey: "unit",
    align: "center",
  },
  {
    width: 144,
    label: `${lang("fields.unitCostShort")} (${lang("currency")})`,
    dataKey: "unitCost",
    align: "right",
    headComponent: CellTooltip,
  },
  {
    width: 144,
    label: `${lang("fields.total")} (${lang("currency")})`,
    dataKey: "total",
    align: "right",
  },
  {
    width: 96,
    label: "%",
    dataKey: "perc",
    align: "center",
  },
];

export const columnsMeasurement: IColumn[] = [
  {
    dataKey: "accumulatedMeasurement",
    align: "center",
    label: lang("measurements.table.measured"),
    width: 350,
    subColumns: [
      {
        width: 120,
        label: lang("fields.quantity"),
        dataKey: "accumulatedQuantity",
        align: "right",
      },
      {
        width: 86,
        label: "%",
        dataKey: "accumulatedPercentual",
        align: "center",
      },
      {
        width: 144,
        label: lang("fields.total"),
        dataKey: "accumulatedTotal",
        align: "right",
      },
    ],
  },
  {
    dataKey: "currentMeasurement",
    align: "center",
    label: lang("measurements.table.current"),
    width: 350,
    subColumns: [
      {
        width: 120,
        label: lang("fields.quantity"),
        dataKey: "currentQuantity",
        align: "right",
        input: true,
        inputType: "number",
      },
      {
        width: 86,
        label: "%",
        dataKey: "currentPercentual",
        align: "center",
        input: true,
        inputType: "number",
      },
      {
        width: 144,
        label: lang("fields.total"),
        dataKey: "currentTotal",
        align: "right",
        input: true,
        inputType: "number",
      },
    ],
  },
  {
    dataKey: "billingMeasurement",
    align: "center",
    label: lang("measurements.table.billing"),
    width: 350,
    subColumns: [
      {
        width: 120,
        label: lang("fields.quantity"),
        dataKey: "billingQuantity",
        align: "right",
      },
      {
        width: 86,
        label: "%",
        dataKey: "billingPercentual",
        align: "center",
      },
      {
        width: 144,
        label: lang("fields.total"),
        dataKey: "billingTotal",
        align: "right",
      },
    ],
  },
];
